import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";

function EditService() {
  const { state: service } = useLocation();
  const [category, setCategory] = useState(service ? service.category : "");
  const [serviceName, setServiceName] = useState(
    service ? service.serviceName : ""
  );
  const [price, setPrice] = useState(service ? service.price : "");
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get("https://visitguru.in/api/v1/category/getCategory")
      .then((res) => setCategories(res.data?.data || []))
      .catch(() => toast.error("Failed to load categories"));
  }, []);

  const handleUpdate = async () => {
    if (!category || !serviceName || !price) {
      toast.error("Please fill in all fields.");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("category", category);
      formData.append("serviceName", serviceName);
      formData.append("price", price);

      const response = await axios.patch(
        `https://visitguru.in/api/v1/service/updateService/${service._id}`,
        formData
      );

      if (response.status === 200 || response.data.success) {
        toast.success("Service updated successfully!");
        navigate("/admin/service");
      } else {
        toast.error(response.data.message || "Update failed.");
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to update service.");
    }
  };

  return (
    <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
      <div className="rounded-t bg-white mb-0 px-6 py-6">
        <div className="text-center flex justify-between">
          <h6 className="text-blueGray-700 text-xl font-bold">Edit Service</h6>
        </div>
      </div>
      <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
        <form onSubmit={(e) => e.preventDefault()}>
          <div className="mb-4">
            <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2 mt-4">
              Category
            </label>
            <select
              className="border-0 px-3 py-3 mt-2 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full"
              value={category}
              onChange={(e) => setCategory(e.target.value)}
            >
              <option value="">Select Category</option>
              {categories.map((cat) => (
                <option key={cat._id} value={cat._id}>
                  {cat.categoryName}
                </option>
              ))}
            </select>
          </div>
          <div className="mb-4">
            <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2 mt-4">
              Service Name
            </label>
            <input
              type="text"
              className="border-0 px-3 py-3 mt-2 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full"
              placeholder="Enter Service Name"
              value={serviceName}
              onChange={(e) => setServiceName(e.target.value)}
            />
          </div>

          {/* Price Input */}
          <div className="mb-4">
            <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2 mt-4">
              Price
            </label>
            <input
              type="number"
              className="border-0 px-3 py-3 mt-2 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full"
              placeholder="Enter Price"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
            />
          </div>

          {/* Buttons */}
          <div className="flex justify-end mt-8">
            <button
              type="button"
              onClick={() => navigate("/admin/service")}
              className="bg-red-500 hover:bg-red-600 text-white font-bold uppercase text-xs px-6 py-3 rounded shadow focus:outline-none focus:ring-2 focus:ring-red-400 transition-all duration-150 mr-4"
            >
              Cancel
            </button>

            <button
              type="button"
              onClick={handleUpdate}
              className="bg-lightBlue-500 hover:bg-lightBlue-600 text-white font-bold uppercase text-xs px-6 py-3 rounded shadow focus:outline-none focus:ring-2 focus:ring-blue-400 transition-all duration-150"
            >
              Update
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditService;
